import { c as _c } from "react/compiler-runtime";
import { Checkbox, HStack, Text, VStack } from '@chakra-ui/react';
import { NativeSelectField, NativeSelectRoot } from '@src/components/chakra-ui/native-select';
import { SESSION_HOUR_SLOTS, SESSION_WEEKDAYS, type SessionDayHours } from '@src/components/sco/Advisors/utils/sessionWeeklyHours';
type SessionWeeklyHoursEditorProps = {
  days: SessionDayHours[];
  onChange: (days: SessionDayHours[]) => void;
};
const slotsWith = (value: string) => SESSION_HOUR_SLOTS.some(slot => slot.value === value) ? SESSION_HOUR_SLOTS : [{
  value,
  label: value
}, ...SESSION_HOUR_SLOTS];
export const SessionWeeklyHoursEditor = t0 => {
  const $ = _c(8);
  const {
    days,
    onChange
  } = t0;
  let t1;
  if ($[0] !== days || $[1] !== onChange) {
    t1 = (weekday, patch) => {
      onChange(days.map(day => day.weekday === weekday ? {
        ...day,
        ...patch
      } : day));
    };
    $[0] = days;
    $[1] = onChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const setDay = t1;
  let t2;
  if ($[3] !== days || $[4] !== setDay) {
    t2 = SESSION_WEEKDAYS.map(meta => {
      const day_0 = days.find(row => row.weekday === meta.key);
      if (!day_0) {
        return null;
      }
      const invalid = day_0.enabled && day_0.end <= day_0.start;
      return <HStack key={day_0.weekday} align="center" gap={3} opacity={day_0.enabled ? 1 : 0.7} wrap="wrap"><Checkbox.Root checked={day_0.enabled} minW="8.5rem" onCheckedChange={details => setDay(day_0.weekday, {
          enabled: !!details.checked
        })}><Checkbox.HiddenInput /><Checkbox.Control><Checkbox.Indicator /></Checkbox.Control><Checkbox.Label>{meta.label}</Checkbox.Label></Checkbox.Root><HStack gap={2} opacity={day_0.enabled ? 1 : 0.45} pointerEvents={day_0.enabled ? "auto" : "none"}><NativeSelectRoot invalid={invalid} minW="7.5rem" size="sm" variant="subtle"><NativeSelectField aria-label={`${meta.label} start`} items={slotsWith(day_0.start)} value={day_0.start} onChange={event => setDay(day_0.weekday, {
              start: event.currentTarget.value
            })} /></NativeSelectRoot><Text color="colorPalette.fg/50" textStyle="sm">to</Text><NativeSelectRoot invalid={invalid} minW="7.5rem" size="sm" variant="subtle"><NativeSelectField aria-label={`${meta.label} end`} items={slotsWith(day_0.end)} value={day_0.end} onChange={event_0 => setDay(day_0.weekday, {
              end: event_0.currentTarget.value
            })} /></NativeSelectRoot></HStack></HStack>;
    });
    $[3] = days;
    $[4] = setDay;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <VStack align="stretch" gap={2}>{t2}</VStack>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};